import React from "react";
import PropTypes from "prop-types";
import "../../../pages/UsedEVs/usedEVs.scss";

import UsedEVCatalog from "../../../components/UsedEVCatalog/UsedEVCatalog";
import MatchScoreOptions from "../../../components/MatchScoreOptions/MatchScoreOptions";
import EvSortControls from "../../../components/EvSortControls/EvSortControls";
import NewUsedEVFilter from "../../components/NewUsedEVFilter/NewUsedEVFilter";
import ModalComponent from "../../../components/ModalUIComponent/ModalUIComponent";

import { FormattedMessage, useIntl } from "react-intl";

const UsedEVs = ({ usedElectricVehicles, ip, uuid, incentives, location }) => {
  const intl = useIntl();

  const time = new Date().toLocaleString();
  let size = window.innerWidth > 600;
  const renderOptions = (
    <>
      {size ? (
        <div id="VehicleTypeFilter" style={{ display: "inline" }}>
          <NewUsedEVFilter value={"used"} />
        </div>
      ) : null}
      <MatchScoreOptions location={location} incentives={incentives} />
    </>
  );

  return (
    <section id="EVs">
      <div className="container main-container">
        <div className="row mb-3 title-box">
          <div className="col-sm-12 text-center">
            <h1 className="page-title">
              <FormattedMessage
                id="header.usedVehicles"
                defaultMessage="Electric Vehicles"
                description="Electric Vehicles"
              />
            </h1>
            <p className="lead">
              {size ? (
                <FormattedMessage
                  id="evs.welcomeSubMobile"
                  defaultMessage="Find new and used EVs to love"
                  description="Description of Colton Recharged"
                />
              ) : (
                <FormattedMessage
                  id="evs.welcomeSubMobile"
                  defaultMessage="Find new and used EVs to love"
                  description="Description of Colton Recharged"
                />
              )}
            </p>
          </div>
        </div>
        <div className="row" style={{ marginTop: "30px" }}>
          <div className="col">
            {size ? null : (
              <div style={{ display: "inline" }}>
                <NewUsedEVFilter value={"used"} />
              </div>
            )}
            <div className="pull-right">
              <EvSortControls />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 d-block d-lg-none text-center">
            <ModalComponent
              buttonText={
                intl.formatMessage
                  ? intl.formatMessage({
                      id: "evs.buttonMatchScoreAndFilters",
                      defaultMessage: "Filters",
                    })
                  : "Filters"
              }
              titleText={
                intl.formatMessage
                  ? intl.formatMessage({
                      id: "evs.matchScoreAndFilters",
                      defaultMessage: "Refine Match Score and Filters",
                    })
                  : "Refine Match Score and Filters"
              }
            >
              {renderOptions}
            </ModalComponent>
            <br />
          </div>
          <div className="col-xl-3 col-lg-4 d-none d-lg-block">
            {renderOptions}
          </div>
          <div
            id="electric-vehicles-catalog"
            aria-live="polite"
            aria-atomic="true"
            role="region"
            style={{ position: "absolute", top: "-9999px" }}
          >
            <span>
              <FormattedMessage
                id="results.updated"
                defaultMessage="Results have been updated as of "
                description="Results have been updated as of "
              />
              {time}.
            </span>
          </div>
          <div
            className="col-xl-9 col-lg-8 col-sm-12"
            style={{ paddingLeft: 10 }}
          >
            <UsedEVCatalog
              vehicles={usedElectricVehicles}
              hasEvDetails
              hasIncentivesAndMatchScore
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default UsedEVs;

UsedEVs.propTypes = {
  electricVehicles: PropTypes.array,
  ip: PropTypes.string,
  uuid: PropTypes.string,
  incentives: PropTypes.array,
  location: PropTypes.object,
};
